import { FinancingResultType } from "../components/FinancingResultModal";

export const useDummyFinancingCompany = false;

export const getDummyFinancingCompany = company => ({
    ...company,
    msic_section: 'B',
    msic_division: '06',
    msic_group: '062',
    financing_consent: 0,
});

export const useDummyFinancingData = false;

export const getDummyFinancingData = () => ({
    msic_code: '062',
    consent_level: 1,
    consented_at: "2024-01-24 13:06:35",
    loans: [{
        id: 0,
        title: "Funding Societies Business Financing",
        subtitle: "Funding Societies provides business financing to SMEs which is crowdfunded by individual and institutional investors at competitive rates.",
        logo_url: "/img/fundingSocieties-logoWithText.svg",
        tenure_min: null,
        tenure_max: 17,
        interest_rate_min: 9.6,
        interest_rate_max: null,
        amount_min: null,
        amount_max: 20000,
        processing_days_standard: 7,
        processing_days_quick: null,
        apply_url: 'http://www.google.com',
        fees_content: "<table><tbody><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Stamp duty</span></th><td colspan='1'><span>0.5%</span></td></tr><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Processing fee</span></th><td colspan='1'><span>RM30.00</span></td></tr><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Early payment fee</span></th><td colspan='1'><span>RM0.00</span></td></tr><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Late payment fee</span></th><td colspan='1'><span>1%</span></td></tr></tbody></table>", // html
        requirements_content: "<table><tbody><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Minimum company age</span></th><td class='ant-descriptions-item-content' colspan='1'><span>1 year</span></td></tr><tr><th colspan='1' style='font-weight: 500; width: 40%;'><span>Annual revenue</span></th><td colspan='1'><span>Min RM 600,000 per year</span></td></tr></tbody></table>", // html
        information_content: null, // html
        created_at: "2023-02-25 13:06:35",
        updated_at: "2023-11-08 14:06:35",
        // loan_results_last_updated_at: null,
        result: {
            tenure: null,
            amount: 6300,
            interest_rate: 6.3,
            apply_url: 'http://www.youtube.com',
            status: FinancingResultType.NOT_QUALIFIED,
            expires_at: "2024-02-09 16:06:35",
            updated_at: "2024-02-06 17:08:35",
        },
        // result: null,
    }],
});

// // first time (no msic submitted)
// const firstTimeDummyFinancingData = {
//     msic_code: null,
//     consent_level: 0,
//     consented_at: null,
//     loans: [
//         {
//             id: 1,
//             title: "Islamic Micro Financing (MF-i)",
//             subtitle: "A shariah compliant micro term facility product under the principles of Commodity Murabahah (via Tawarruq).",
//             logo_url: "/img/fundingSocieties-logoWithText.svg",
//             tenure_min: 6,
//             tenure_max: 18,
//             interest_rate_min: 9.6,
//             interest_rate_max: 18,
//             amount_min: 3000,
//             amount_max: 200000,
//             processing_days_standard: 7,
//             processing_days_quick: 1,
//             apply_url: "https://fundingsocieties.com/",
//             fees_content: "<table>\n                    <tbody>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Profit Rate</span></th>\n                            <td colspan='1'><span>From 9.6% p.a. to 18% p.a.</span></td>\n                        </tr>\n\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Drawdown Fee</span></th>\n                            <td colspan='1'><span>5% of facility amount charged upon successful disbursements.</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Guarantee Fee</span></th>\n                            <td colspan='1'><span>5% of financing amount charged upon successful disbursements.</span></td>\n                        </tr>\n                    </tbody>\n                </table>",
//             requirements_content: "<table>\n                    <tbody>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Years of Operation</span></th>\n                            <td class='ant-descriptions-item-content' colspan='1'><span>Min 6 months</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Annual Revenue</span></th>\n                            <td colspan='1'><span>Min RM600,000 per year</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Shareholding</span></th>\n                            <td colspan='1'><span>Min 30% Malaysians registered company</span></td>\n                        </tr>\n                    </tbody>\n                </table>",
//             information_content: null,
//             result: null,
//             created_at: "2023-12-04 18:11:58",
//             updated_at: "2023-12-04 18:11:58",
//         },
//     ],
// };

// // gone through MSIC but don't give consent
// const noConsentDummyFinancingData = {
//     msic_code: "143",
//     consent_level: 0,
//     consented_at: "2024-02-06 17:32:30",
//     loans: [
//         {
//             id: 1,
//             title: "Islamic Micro Financing (MF-i)",
//             subtitle: "A shariah compliant micro term facility product under the principles of Commodity Murabahah (via Tawarruq).",
//             logo_url: "/img/fundingSocieties-logoWithText.svg",
//             tenure_min: 6,
//             tenure_max: 18,
//             interest_rate_min: 9.6,
//             interest_rate_max: 18,
//             amount_min: 3000,
//             amount_max: 200000,
//             processing_days_standard: 7,
//             processing_days_quick: 1,
//             apply_url: "https://fundingsocieties.com/",
//             fees_content: "<table>\n                    <tbody>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Profit Rate</span></th>\n                            <td colspan='1'><span>From 9.6% p.a. to 18% p.a.</span></td>\n                        </tr>\n\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Drawdown Fee</span></th>\n                            <td colspan='1'><span>5% of facility amount charged upon successful disbursements.</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Guarantee Fee</span></th>\n                            <td colspan='1'><span>5% of financing amount charged upon successful disbursements.</span></td>\n                        </tr>\n                    </tbody>\n                </table>",
//             requirements_content: "<table>\n                    <tbody>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Years of Operation</span></th>\n                            <td class='ant-descriptions-item-content' colspan='1'><span>Min 6 months</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Annual Revenue</span></th>\n                            <td colspan='1'><span>Min RM600,000 per year</span></td>\n                        </tr>\n                        <tr>\n                            <th colspan='1' style='font-weight: 500; width: 40%;'><span>Shareholding</span></th>\n                            <td colspan='1'><span>Min 30% Malaysians registered company</span></td>\n                        </tr>\n                    </tbody>\n                </table>",
//             information_content: null,
//             result: null,
//             created_at: "2023-12-04 18:11:58",
//             updated_at: "2023-12-04 18:11:58",
//         },
//     ],
// };
